import React from "react";
import ClipLoader from "react-spinners/BounceLoader";

export default function Error() {
  return (
    <div className="orenda-frontend">
      <div className="loader bounce">
        <p>Please wait...</p>
        <ClipLoader size={30} />
      </div>
    </div>
  );
}
